'use client';

import React from 'react';
import clsx from 'clsx';

import { SidebarArrow } from '@/icons/SidebarArrow';
import { CategoryItem } from '@/shared/Sidebar/components/CategoryItem';
import { SidebarCategoryIsActive } from '@/lib/models/Sidebar';
import { useSidebarContext } from '@/lib/providers/SidebarProvider';
import { StickyScrollWrapper } from '@/shared/StickyScrollWrapper';

import styles from './SidebarContent.module.scss';

interface SidebarContentProps {
  type: string;
  categories: SidebarCategoryIsActive[];
  activeSlug: string[];
}

export function SidebarContent({ categories, type, activeSlug }: SidebarContentProps) {
  const { isCollapsed, toggleSidebar } = useSidebarContext();

  const url = `/helpdesk/${type}`;

  return (
    <aside
      className={clsx(styles.sidebar, 'text text-sm', {
        [styles.collapsed]: isCollapsed,
      })}
    >
      <div className={styles.sidebarInner}>
        <div className={styles.arrowWrapper}>
          <SidebarArrow isCollapsed={isCollapsed} onClick={toggleSidebar} />
        </div>
        <StickyScrollWrapper top={100}>
          <div className={styles.hiddenContent}>
            <div className={styles.sidebarContent}>
              <nav className={clsx(styles.nav, isCollapsed && styles.hidden)}>
                {categories.map((category) => (
                  <CategoryItem key={category.id} baseUrl={url} category={category} activeSlug={activeSlug} level={0} type={type} />
                ))}
              </nav>
            </div>
          </div>
        </StickyScrollWrapper>
      </div>
    </aside>
  );
}
